export const UNREAD_WINDOW_DAYS = 7;
export const READ_TIME_THRESHOLD_MS = 3_000; // 3s
export const READ_ITEMS_STORAGE_KEY = 'appUpdatesReadItems';
export const LAST_PRUNED_STORAGE_KEY = 'appUpdatesLastPruned';
